/**
 * Normaliza un label de UI a un valor de payload de tracking: minúsculas, sin
 * acentos y con guiones bajos. Los payloads de eventos NO llevan valores con
 * espacios ni mayúsculas.
 */
export const toSnakeCaseLabel = (label: string): string =>
	label
		.toLowerCase()
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.replace(/\s+/g, '_');

// Deep snake_case conversion for objects/arrays returned by services that
// expose camelCase shapes (e.g. mapped responses from `changeItemShoppingCart`).
//
// Signature is intentionally `unknown -> unknown`: the function doesn't know
// (and cannot statically verify) the shape of what you hand it. Callers are
// responsible for asserting the result type after the conversion — usually
// with `Array.isArray` + a cast — so the unsafety is visible at the call
// site instead of hidden by a misleading generic parameter.

export const toSnakeCase = (value: unknown): unknown => {
	if (Array.isArray(value)) {
		return value.map((item) => toSnakeCase(item));
	}

	if (value !== null && typeof value === 'object') {
		return Object.keys(value as Record<string, unknown>).reduce<
			Record<string, unknown>
		>((acc, key) => {
			const snakeKey = key.replace(
				/[A-Z]/g,
				(letter) => `_${letter.toLowerCase()}`,
			);
			acc[snakeKey] = toSnakeCase((value as Record<string, unknown>)[key]);
			return acc;
		}, {});
	}

	return value;
};
